var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearceImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1062,
    height: 864,
    viewBox: "0 0 1062 864",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Results"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M35.5338 393.926V402.926",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M15.3219 398.801L22.6762 406.371",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M6.72034 418.957H17.1192",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M14.4811 439.465L21.8354 431.895",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M35.5338 441.926V432.926",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 10",
    d: "M50.5338 435.926L44.5338 429.926",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M62.5338 420.926H53.5338",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    d: "M56.5338 399.926L50.5338 405.926",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M518.534 0.925781V6.92578",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M500.534 18.9258H506.534",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M518.534 36.9258V30.9258",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M533.534 18.9258H527.534",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M170.534 252.926V261.926",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M143.534 279.926H152.534",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M170.534 303.926V294.926",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M194.534 279.926H185.534",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    d: "M816.297 580.043C823.467 580.043 829.281 585.859 829.281 593.03C829.281 600.204 823.467 606.018 816.297 606.018C809.128 606.018 803.313 600.204 803.313 593.03",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.721 462.216C883.43 459.811 895.247 450.383 897.983 440.238C900.463 449.206 910.862 459.811 920.245 460.614C909.683 464.353 899.585 475.463 897.983 484.191C896.893 475.295 882.926 463.513 875.721 462.216Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3534 576.042C88.2094 574.84 94.1156 570.127 95.4832 565.055C96.7236 569.536 101.922 574.84 106.613 575.242C101.333 577.11 96.2855 582.666 95.4832 587.03C94.9382 582.582 87.9547 576.689 84.3534 576.042Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.911 158.723C155.911 164.287 151.403 168.793 145.843 168.793C140.281 168.793 135.775 164.287 135.775 158.723C135.775 153.161 140.281 148.652 145.843 148.652C151.403 148.652 155.911 153.161 155.911 158.723Z",
    fill: "#D1D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M828.193 185.757C828.193 195.053 820.657 202.589 811.366 202.589C802.07 202.589 794.536 195.053 794.536 185.757C794.536 176.461 802.07 168.926 811.366 168.926C820.657 168.926 828.193 176.461 828.193 185.757Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.28 140.16C1061.28 147.535 1055.3 153.512 1047.93 153.512C1040.56 153.512 1034.59 147.535 1034.59 140.16C1034.59 132.785 1040.56 126.809 1047.93 126.809C1055.3 126.809 1061.28 132.785 1061.28 140.16Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.066 763.726C344.066 768.375 340.3 772.143 335.651 772.143C331.006 772.143 327.239 768.375 327.239 763.726C327.239 759.076 331.006 755.309 335.651 755.309C340.3 755.309 344.066 759.076 344.066 763.726Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.061 94.0236C339.061 99.5874 334.553 104.094 328.993 104.094C323.433 104.094 318.925 99.5874 318.925 94.0236C318.925 88.4623 323.433 83.9531 328.993 83.9531C334.553 83.9531 339.061 88.4623 339.061 94.0236Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.872 856.937C589.438 859.385 582.238 856.152 579.791 849.72C577.343 843.285 580.573 836.08 587.008 833.635C593.439 831.187 600.639 834.417 603.087 840.852C605.537 847.287 602.305 854.489 595.872 856.937Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.037 618.926H346.023C328.707 618.926 314.533 604.71 314.533 587.336V236.508C314.533 219.134 328.707 204.926 346.023 204.926H592.037C609.36 204.926 623.533 219.134 623.533 236.508V587.336C623.533 604.71 609.36 618.926 592.037 618.926Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.037 633.926H325.023C307.707 633.926 293.533 619.71 293.533 602.336V251.508C293.533 234.134 307.707 219.926 325.023 219.926H571.037C588.36 219.926 602.533 234.134 602.533 251.508V602.336C602.533 619.71 588.36 633.926 571.037 633.926Z",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.611 645.77H304.088C286.737 645.77 272.534 631.613 272.534 614.311V264.936C272.534 247.634 286.737 233.484 304.088 233.484H550.611C567.969 233.484 582.173 247.634 582.173 264.936V614.311C582.173 631.613 567.969 645.77 550.611 645.77Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.611 645.77H304.088C286.737 645.77 272.534 631.613 272.534 614.311V264.936C272.534 247.634 286.737 233.484 304.088 233.484H550.611C567.969 233.484 582.173 247.634 582.173 264.936V614.311C582.173 631.613 567.969 645.77 550.611 645.77Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.077 339.926H332.99C327.79 339.926 323.533 335.876 323.533 330.929C323.533 325.975 327.79 321.926 332.99 321.926H515.077C520.277 321.926 524.533 325.975 524.533 330.929C524.533 335.876 520.277 339.926 515.077 339.926Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.077 393.926H332.99C327.79 393.926 323.533 389.876 323.533 384.929C323.533 379.975 327.79 375.926 332.99 375.926H515.077C520.277 375.926 524.533 379.975 524.533 384.929C524.533 389.876 520.277 393.926 515.077 393.926Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.077 447.926H332.99C327.79 447.926 323.533 443.876 323.533 438.929C323.533 433.982 327.79 429.926 332.99 429.926H515.077C520.277 429.926 524.533 433.982 524.533 438.929C524.533 443.876 520.277 447.926 515.077 447.926Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.077 501.926H332.99C327.79 501.926 323.533 497.876 323.533 492.929C323.533 487.975 327.79 483.926 332.99 483.926H515.077C520.277 483.926 524.533 487.975 524.533 492.929C524.533 497.876 520.277 501.926 515.077 501.926Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.036 555.926H333.03C327.808 555.926 323.533 551.876 323.533 546.929C323.533 541.975 327.808 537.926 333.03 537.926H428.036C433.259 537.926 437.533 541.975 437.533 546.929C437.533 551.876 433.259 555.926 428.036 555.926Z",
    fill: "#E0E2EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.798 486.136C583.388 522.54 527.021 526.647 486.099 498.54C480.869 494.884 475.891 490.777 471.249 486.136C468.859 483.754 466.607 481.296 464.485 478.709C460.24 473.541 456.522 468.03 453.475 462.335C448.108 452.717 444.459 442.511 442.466 431.962C436.038 398.878 445.65 363.268 471.249 337.681C496.909 312.017 532.526 302.468 565.615 308.834C576.158 310.887 586.373 314.536 595.993 319.842C601.696 322.956 607.132 326.673 612.309 330.918C614.889 333.032 617.348 335.292 619.73 337.681C624.379 342.322 628.548 347.291 632.136 352.528C660.255 393.436 656.14 449.801 619.798 486.136Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609.61 478.966C571.73 516.853 510.343 516.846 472.456 478.966C434.619 441.129 434.619 379.734 472.506 341.855C510.343 304.017 571.73 304.017 609.568 341.855C647.447 379.734 647.447 441.129 609.61 478.966ZM629.05 322.392C580.428 273.77 501.638 273.77 453.016 322.392C404.401 371.007 404.359 449.847 452.974 498.469C497.225 542.707 566.585 546.697 615.369 510.374C620.134 506.822 624.722 502.839 629.1 498.469C633.47 494.092 637.452 489.503 640.998 484.738C677.32 435.947 673.295 366.637 629.05 322.392Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.4 681.751L818.358 683.792C804.854 697.304 782.739 697.304 769.228 683.792L644.533 559.098L695.705 507.926L820.4 632.62C833.911 646.132 833.911 668.239 820.4 681.751Z",
    fill: "url(#paint0_linear_5259_34501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.686 480.926L680.533 517.773L654.374 543.926L617.533 507.078C622.396 503.453 627.071 499.389 631.545 494.93C636.004 490.47 640.068 485.788 643.686 480.926Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M818.533 631.087L767.687 681.926L758.533 672.765L809.373 621.926L818.533 631.087Z",
    fill: "#769E2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.533 509.686L646.295 561.926L638.533 554.165L690.772 501.926L698.533 509.686Z",
    fill: "url(#paint1_linear_5259_34501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M584.533 328.822L456.423 456.926C451.598 448.279 448.318 439.104 446.533 429.62L557.226 318.926C566.704 320.779 575.886 324.052 584.533 328.822Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.533 359.271L488.032 489.926C483.072 486.661 478.351 482.986 473.949 478.832C471.682 476.694 469.539 474.502 467.533 472.186L607.722 339.926C610.177 341.825 612.508 343.847 614.767 345.985C619.17 350.138 623.13 354.585 626.533 359.271Z",
    fill: "white",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5259_34501",
    x1: 737.533,
    y1: 414.926,
    x2: 551.533,
    y2: 600.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1FB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D890E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5259_34501",
    x1: 668.533,
    y1: 471.926,
    x2: 608.533,
    y2: 531.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C9C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73964C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearceImage);
export default __webpack_public_path__ + "static/media/EmptySearceImage.98634048e6d11fd75012a4915b6e11c1.svg";
export { ForwardRef as ReactComponent };